export default __webpack_public_path__ + "static/media/icn-consumption-rpm.57bcb381.svg";